/**
 * Build a registry of cell renderers keyed by component name. The registry is
 * consumed by the grid config layer to resolve string-named `cellRenderer`
 * entries from site-content JSON.
 *
 * Sources:
 *  - Built-in platform renderers under `libs/gu-datagrid-n/src/cell-renderers/**`
 *  - Customer-supplied renderers under `customers/<id>/components/cell-renderers/**`
 */
export function useCellRenderers () {
  const cellRenderers = {}

  const platformModules = import.meta.glob('../cell-renderers/**/*CellRenderer.vue', { eager: true })
  const customerModules = import.meta.glob('../../../../customers/*/components/cell-renderers/**/*CellRenderer.vue', { eager: true })

  // Register platform renderers first so customer renderers win conflicts.
  Object.entries(platformModules).forEach(([path, module]) => {
    const componentName = path.split('/').pop().replace(/\.vue$/, '')
    cellRenderers[componentName] = module.default
  })

  Object.entries(customerModules).forEach(([path, module]) => {
    const componentName = path.split('/').pop().replace(/\.vue$/, '')
    cellRenderers[componentName] = module.default
  })

  return {
    cellRenderers,
  }
}
